import React from 'react'
import styled from '@emotion/styled'
import './style.scss'

const Box = styled.div`
  padding: ${(props) => props.scale * 20}px;
`;

const Link = styled.a`
    text-decoration: none !important;
    display initial;
    z-index: 10;
`

const Review = styled.div`
  width: ${(props) => props.scale * 575}px;
  display: flex;
  padding: ${(props) => props.scale * 20}px;
  background: #fff;
  border-radius: 4px;
  box-shadow: 0 7px 20px 0 rgba(0, 0, 0, 0.12);
`;

const Avatar = styled.div`
  border-radius: 50%;
  width: ${(props) => props.scale * 58}px;
  height: ${(props) => props.scale * 58}px;
  overflow: hidden;
  flex-shrink: 0;
  margin-right: ${(props) => props.scale * 15}px;
  img {
    max-width: 100%;
  }
`;

const ContentContainer = styled.div``;

const Text = styled.p`
    margin: 0;
    color: #9c9c9c;
    font-family: Poppins, sans-serif;
    font-weight: 400 !important;
    font-size: 14px !important;
    line-height: ${(props) => props.scale * 20}px;
    font-weight: 100;
    text-align: left;
`

const Signature = styled.span`
    color: #444444;
    z-index: 1;
`

const Name = styled.label`
    font-family: Poppins, sans-serif;
    font-weight: 300 !important;
    font-size: 14px;
    color: #444444;
`

const Company = styled.label`
    font-family: Poppins, sans-serif;
    font-weight: 500 !important;
    font-size: 14px;
    color: #444444;
`


const Index = ({scale, details}) => {
    return(
        <Box key={`marquee-example-review`} scale={scale}>
            <Link href={details.url}>
                <Review scale={scale}>
                    <Avatar scale={scale}>
                    <img src={details.thumbnail} alt={details.name} />
                    </Avatar>
                    <ContentContainer scale={scale}>
                    <Text>{details.text}</Text>
                    <Signature><Name>{details.name}</Name>, <Company>{details.company}</Company></Signature>
                    </ContentContainer>
                </Review>
            </Link>
        </Box>
    )
}

export default Index